import React from 'react';
import styles from './Footer.module.css';

const Footer = () => (
    <div className={styles.center}>
        <p>©{new Date().getFullYear()} AirGarage, Inc</p>
        <ul className={styles.horizontalList}>
            <li>
                <a href="https://airgarage.com/">Homepage</a>
            </li>
            <li>
                <a href="https://airgarage.com/terms">Terms</a>
            </li>
            <li>
                <a href="https://help.airgarage.com/hc/en-us/requests/new">Contact us</a>
            </li>
        </ul>
    </div>
);

export default Footer;
